import { OrderDelivery } from '../../model'
import DeliveryItem from '../../pages/Deliveries/DeliveryItem'
import { useDeliveries } from '../../hooks/useDeliveries'
import { NavLink } from 'react-router-dom'

interface DeliveriesWidgetProps {
    size?: number
}

const DeliveriesWidget = ({ size = 4 }: DeliveriesWidgetProps) => {
    const { deliveryList, getDeliveries } = useDeliveries()

    const deliveries = deliveryList.slice(0, size)

    return (
        <div className='bg-white shadow-sm border-full overflow-hidden rounded-xl h-auto pt-0'>
            <div className='flex flex-col'>
                {deliveries.length === 0 ? (
                    <div className='text-center text-gray-400 py-8'>Geen opleveringen</div>
                ) : (
                    deliveries.map((delivery: OrderDelivery) => {
                        return (
                            <NavLink
                                key={delivery.id}
                                to={`/dashboard/orders/order/${delivery.order?.id}`}
                                state={{ order: delivery.order }}
                                className='border-btm hover:bg-gray-50 hover:cursor-pointer first:pt-2 first:rounded-t-xl last:rounded-b-xl'
                            >
                                <DeliveryItem data={delivery} onDownload={getDeliveries} />
                            </NavLink>
                        )
                    })
                )}
            </div>
        </div>
    )
}

export default DeliveriesWidget
